import cx from 'classnames';
import COLORS from '../colorConstants';
import useHover from '../hooks/useHover';
import { useViewNotifications } from '../context/ViewNotificationsProvider';

const ViewNotificationsIcon = ({ active = false, ...rest }) => {
  const [hoverRef, isHovered] = useHover();
  const { unreadNotificationsCount } = useViewNotifications();

  const bgColors = {
    active: `${COLORS.PURPLE_1}1a`,
    hover: COLORS.WHITE_2,
    normal: COLORS.WHITE_9,
  };

  const fileColors = {
    normal: COLORS.BLACK_3,
    active: COLORS.PURPLE_1,
  };

  return (
    <div className="view-downloads-icon" ref={hoverRef}>
      {!!unreadNotificationsCount && (
        <div className="counter animated-counter">
          <p className="counter-text">{unreadNotificationsCount}</p>
        </div>
      )}
      <svg
        width={40}
        height={40}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...rest}
      >
        <g clipPath="url(#clip0_45745_26583)">
          <path
            d="M21.1456 27.7341C21.7752 27.7341 22.2857 28.2413 22.2857 28.867C22.2857 29.4928 21.7752 30 21.1456 30H18.8655C18.2359 30 17.7255 29.4928 17.7255 28.867C17.7255 28.2413 18.2359 27.7341 18.8655 27.7341H21.1456ZM20.0056 10C20.88 10 21.589 10.7089 21.589 11.5834L21.5896 12.7139C22.8188 12.9977 23.9597 13.6093 24.8817 14.4983C26.243 15.811 27.0109 17.6165 27.01 19.5021V23.8554C27.01 24.3362 27.402 24.726 27.8856 24.726C28.3691 24.726 28.7611 25.1158 28.7611 25.5967C28.7611 26.0775 28.3691 26.4673 27.8856 26.4673H12.1256C11.642 26.4673 11.25 26.0775 11.25 25.5967C11.25 25.1158 11.642 24.726 12.1256 24.726C12.6091 24.726 13.0011 24.3362 13.0011 23.8554V19.7546C12.9669 16.4 15.2645 13.5416 18.4218 12.7453L18.4222 11.5834C18.4222 10.7089 19.1311 10 20.0056 10Z"
            fill={cx({
              [fileColors.normal]: true,
            })}
          />
        </g>
        <defs>
          <clipPath id="clip0_40133_79267">
            <rect width="40" height="40" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
};

export default ViewNotificationsIcon;
